import { Phone } from "@phosphor-icons/react";

export default function FloatingCallButton() {
  return (
    <a
      href="tel:+15034828686"
      data-testid="floating-call-button"
      className="fixed bottom-6 right-6 z-50 md:hidden w-14 h-14 rounded-full bg-primary text-primary-foreground flex items-center justify-center shadow-lg hover:bg-primary/90 hover:scale-105 active:scale-95 transition-transform"
      aria-label="Call Mobile Mechanic PDX"
    >
      <Phone weight="fill" className="w-6 h-6" />
    </a>
  );
}
